import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import facebookIcon from '@assets/icons/icon-facebook.svg';
import instagramIcon from '@assets/icons/icon-instagram.svg';
import hashtag from '@assets/images/zaslouzisivic.webp';
import socialMediaDog from '@assets/images/social-media-dog.webp';



const Contact = () => {
	const { t } = useTranslation([ 'web', 'links' ]);

	return (
		<div className="app-page contact-page">
			
			<h1>{t('pages.contact.header')}</h1>

			<div className='contact-address'>
				
				<p>{t('pages.contact.contactAddress.companyName')}</p>
				
				<p>{t('pages.contact.contactAddress.address')}<br />
					<span>{t('pages.contact.contactAddress.companyId') + ': '}</span>{t('pages.contact.contactAddress.companyIdValue')}<br />
					<span>{t('pages.contact.contactAddress.taxId') + ': '}</span>{t('pages.contact.contactAddress.taxIdValue')}</p>
			</div>

			<div className='contact-links'>
				<p>
					<span>{t('pages.contact.contactLinks.email') + ': '}</span>
					{t('pages.contact.contactLinks.emailValue')}
				</p>
				<p>
					<span>{t('pages.contact.contactLinks.phone') + ': '}</span>
					{t('pages.contact.contactLinks.phoneValue')}
				</p>
				<p>
					<span>{t('pages.contact.contactLinks.web') + ': '}</span>
					<Link to={`https://${t('pages.contact.contactLinks.webValue')}`} className='disable-selection'>
						{t('pages.contact.contactLinks.webValue')}
					</Link>
				</p>
				<p>
					<span>{t('pages.contact.contactLinks.socialMedia') + ':'}</span>
				</p>

				<div className='social-media-icons'>
					<Link to={t('socialMedia.facebook', { ns: 'links' })} className='disable-selection' target='_blank'>
						<img src={facebookIcon} alt='social-media-facebook' />
					</Link>

					<Link to={t('socialMedia.instagram', { ns: 'links' })} className='disable-selection' target='_blank'>
						<img src={instagramIcon} alt='social-media-instagram' />
					</Link>
				</div>
			</div>

			<div className='social-media-hashtag'>
				<img src={hashtag} alt='social-media-hashtag' />	
			</div>

			<div className='social-media-photo'>
				<img src={socialMediaDog} alt='social-media-photo' />	
			</div>

		</div>
	);
};

export default Contact;